module.exports = __webpack_public_path__ + "static/fonts/NotoSansKR-Bold.11ec013.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/nca/css/font/NotoSansKR-Bold.woff
// module id = QANy
// module chunks = 0